module.exports = __webpack_public_path__ + "img/ic_3.ada209eb.png";